import { gql } from '@apollo/client'

export const CUBE_DIMENSIONS = gql`
  fragment CubeDimensions on CubeDimensions {
    width
    height
    depth
  }
`
